<template>
  <div class="cmp-accordion-container">
    <div
      class="accordion-item"
      v-for="(chapter, index) in pluginLists"
      :index="index"
      :key="chapter.chapterName"
      :class="{ open: active_el == chapter.chapterName }"
      @click="toggleOpen(chapter.chapterName)"
    >
      <div class="accordion-item-header">
        <b>{{ chapter.chapterName }}</b>
        <img
          src="static/icons/arrows/chevron-down.svg"
          alt
          class="dt-icon v6 s1 h0"
        />
      </div>
      <div class="accordion-item-body" @click.stop="">
        <div
          class="row"
          v-for="(pluginItem, index) in chapter.pluginList"
          :index="index"
          :key="pluginItem.index"
        >
          <span class="column col-4 plugin-name">{{ pluginItem.name }}</span>
          <div class="column plugin-info-col">
            <div class="plugin-info">
              <v-tooltip left>
                <template slot="activator">
                  <span class="pointer">Info</span>
                </template>
                <span v-html="pluginItem.description"></span>
              </v-tooltip>
            </div>
          </div>
          <div class="column">
            <button
              v-if="isActive"
              class="dt-button v1 s6"
              @click="openAdapter(pluginItem)"
            >
              ▶ Run
            </button>
            <button
              v-if="isAvailable"
              class="dt-button v1 s6"
              @click="activatePlugin(pluginItem)"
            >
              + Activate
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uniq } from "ramda";
export default {
  props: ["plugins", "pluginType"],
  data() {
    return {
      btnPluginsType: "Run".toUpperCase(),
      active_el: "",
    };
  },
  methods: {
    toggleOpen: function (el) {
      console.log("Log: el", el);
      console.log("Log: this.active_el", this.active_el);
      if (this.active_el == el) {
        this.active_el = "";
      } else {
        this.active_el = el;
      }
    },
    openDialog(pluginItemName) {
      this.$emit("openModal", pluginItemName);
    },
    openAdapter(pluginItemName) {
      this.$emit("openAdapter", pluginItemName);
    },
    activatePlugin(pluginItemName) {
      this.$emit("activate", pluginItemName);
    },
  },
  computed: {
    chapterList() {
      return uniq(this.plugins.map((e) => e.chapter_computed));
    },
    pluginLists() {
      return this.chapterList.map((e) => {
        return {
          chapterName: e,
          pluginList: this.plugins.filter((x) => x.chapter_computed == e),
        };
      });
    },
    isActive: function () {
      return this.pluginType == "active";
    },
    isAvailable: function () {
      return this.pluginType == "available";
    },
  },
};
</script>

<style lang="scss" scoped>
.cmp-accordion-container {
  max-height: calc(100vh - 220px);
  .accordion-item {
    margin-bottom: 2px;
    .accordion-item-header {
      /* background-color: hsl(24, 40%, 96%); */
      color: #282828;
      padding: 5px 10px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      user-select: none;

      .dt-icon {
        transition: all 0.3s linear;
        transform: rotate(0deg);
        position: absolute;
        right: 10px;
        top: 8px;
      }
    }
    .accordion-item-body {
      opacity: 0;
      max-height: 0;
      overflow: hidden;
      transition: all 0.3s ease;

      .row {
        align-items: center;
        border-bottom: 1px solid #c8c8c8;
        padding: 5px 10px;
      }
    }

    &.open {
      .accordion-item-header {
        .dt-icon {
          transform: rotate(180deg);
        }
      }
      .accordion-item-body {
        opacity: 1;
        max-height: 100%;
      }
    }
  }

  .accordion-item:last-child {
    .accordion-item-body {
      .row:last-child {
        border-bottom: none;
      }
    }
  }
}
.row {
  display: flex;
  flex-wrap: wrap;

  .column {
    flex: 1;

    &.plugin-name {
      flex-grow: 4;
      padding: 0px 4px 0px 0px;
    }
    &.plugin-info-col {
      flex-grow: 2;
      padding: 0px 4px 0px 4px;
    }
  }
}

.dialog {
  box-shadow: none !important;
}
.pointer {
  cursor: pointer;
}
</style>
